// extracted by mini-css-extract-plugin
module.exports = {"alGhadeerParagraph":"style_alGhadeerParagraph__gnZKD"};